import styled from 'styled-components';
import Box from '../Box';

const Col = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export default Col;
